module.exports = __webpack_public_path__ + "img/ezugi.8d6d0be7.svg";